import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, InputLabel, SvgIcon, Tooltip } from '@material-ui/core';
import TextInput from 'components/Forms/Fields/TextInput';
import { useTranslation } from 'react-i18next';
import { formatMessage } from 'utils/methods/helpers';
import { ReactComponent as DeleteIcon } from 'images/icon_trash.svg';
import { ReactComponent as AddIcon } from 'images/icon_add_new.svg';
import staticText from 'static/text_display.json';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  mySvgStyle: {
    height: '25px', //*[@id="Layer_1"]/g/path
    width: '25px',
    cursor: 'pointer',
    '& [id="Layer_1"]': {
      color: `${theme.palette.text.primary} !important`,
      '& [class*="st0"]': {
        fill: `${theme.palette.text.primary} !important`,
      },
    },
  },

  mySvgStyleAddIcon: {
    height: '25px', //*[@id="Layer_1"]/g/path
    width: '25px',
    cursor: 'pointer',
    '& [id="Layer_1"]': {
      color: `${theme.palette.secondary.light} !important`,
      '& [class*="st0"]': {
        fill: `${theme.palette.secondary.light} !important`,
      },
    },
  },

  buttonContainer: {
    height: '2.5rem',
    width: '2.5rem',
    background: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    borderRadius: '10%',
  },
}));

const DynamicTextGenerator = ({
  id,
  label,
  className,
  required,
  field,
  error,
  disabled,
  hidden,
  info,
  setFieldValue,
  // onChange,
}) => {
  const [list, setList] = useState([]);
  const { t } = useTranslation();
  const classes = useStyles();
  const handleChange = (e, key) => {
    const textFieldName = e.target.name;
    const textFieldVal = e.target.value;
    const newList = list.map((item, sidx) => {
      if (key !== sidx) return item;
      // by default assign a key 'selected' as false
      return { ...item, [textFieldName]: textFieldVal, selected: false };
    });
    setList(newList);
    setFieldValue(field, newList);
  };
  const removeAddedItem = key => {
    const filteredResults = list.filter((_, sidx) => key !== sidx);
    setList(filteredResults);
    setFieldValue(field, filteredResults);
  };

  const handleButtonClick = () => {
    setList(prev => [...prev, { title: '' }]);
  };

  useEffect(() => {
    return () => {
      // clear the state
      setList([]);
    };
  }, [hidden]);

  return (
    <>
      <div
        style={{
          width: '100%',
          flexDirection: 'column',
          alignItems: 'flex-start',
          display: `${hidden ? 'none' : 'flex'}`,
        }}
      >
        {label && (
          <InputLabel
            shrink
            disableAnimation
            required={required}
            htmlFor="component-error"
            variant="standard"
            focused={false}
          >
            {t(label)}
            {info && <Tooltip text={info} />}
          </InputLabel>
        )}
        <div className={classes.buttonContainer}>
          <IconButton
            color="primary"
            component="div"
            onClick={handleButtonClick}
            title={t(
              formatMessage({
                message: 'Add text options',
              }),
            )}
          >
            <SvgIcon className={classes.mySvgStyleAddIcon}>
              <AddIcon />
            </SvgIcon>
          </IconButton>
        </div>
      </div>
      <br />
      {list.map((item, key) => (
        <div
          style={{
            paddingBottom: '10px',
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'flex-start',
          }}
          key={key}
        >
          <TextInput
            id={id}
            key={key + 1}
            className={className}
            required={required}
            field={'title'}
            onChange={e => handleChange(e, key)}
            value={item.title}
            error={error}
            disabled={disabled}
            hidden={hidden}
          />
          <IconButton
            color="secondary"
            component="div"
            onClick={() => removeAddedItem(key)}
            title={t(
              formatMessage({
                message: staticText.general.delete_value,
              }),
            )}
          >
            <SvgIcon className={classes.mySvgStyle}>
              <DeleteIcon />
            </SvgIcon>
          </IconButton>
        </div>
      ))}
    </>
  );
};

DynamicTextGenerator.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  info: PropTypes.object,
  setFieldValue: PropTypes.func,
};

export default DynamicTextGenerator;
